import { lazy } from 'react';

import { RouterSuspense } from '@/lib';

export const RegistriesPreviewPageAsync = RouterSuspense(
  lazy(() => import('./index.tsx')),
);
